import {
  getDefaultPeriodMaxDate,
  getDefaultPeriodMinDate,
} from '~domains/commerce/features/period-filter';

import { getDefaultPeriodPresets } from '~shared/ui/date-range-picker';

export const PERIOD_PRESETS = getDefaultPeriodPresets();

export const PERIOD_MIN_DATE = getDefaultPeriodMinDate();

export const PERIOD_MAX_DATE = getDefaultPeriodMaxDate();
